import { render, staticRenderFns } from "./TransferOrder.vue?vue&type=template&id=589493c5&scoped=true&"
import script from "./TransferOrder.vue?vue&type=script&lang=js&"
export * from "./TransferOrder.vue?vue&type=script&lang=js&"
import style0 from "./TransferOrder.vue?vue&type=style&index=0&id=589493c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589493c5",
  null
  
)

export default component.exports